module.exports = __webpack_public_path__ + "img/LT112040352.68857891.png";